var _templateObject;
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';
export { default as HeadProvider } from './headProvider';
import { Helmet } from 'react-helmet-async';
Helmet.defaultProps.defer = false;
export var Meta = props => {
  var {
      children
    } = props,
    tagProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("meta", tagProps, children));
};
export var Title = props => {
  var {
      children
    } = props,
    tagProps = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", tagProps, children));
};
var STORE_NAME_QUERY = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query getStoreName {\n        storeConfig {\n            id\n            store_name\n        }\n    }\n"])));
export var StoreTitle = props => {
  var {
      children
    } = props,
    tagProps = _objectWithoutProperties(props, _excluded3);
  var {
    data: storeNameData
  } = useQuery(STORE_NAME_QUERY, {
    fetchPolicy: 'cache-and-network'
  });
  var titleText;
  if (children) {
    titleText = "".concat(children);
  } else {
    titleText = storeNameData ? storeNameData.storeConfig.store_name : STORE_NAME;
  }
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", tagProps, titleText));
};